import { useSelector } from 'react-redux';
import { usePortalUrl } from '.';
import projectGrouping from '../../../../redux/project_grouping';

/** hook to return the url of a specific report in the portal. */
function useReportUrl() {
  const { url } = usePortalUrl();
  const { projectGroupId, id: releaseId } = useSelector(projectGrouping.selectors.getRelease);
  const currentGroup = useSelector((state) => projectGrouping.selectors.getCurrentProjectGroup(state, {
    params: { projectGroupId },
  }));

  return {
    url: url && projectGroupId && releaseId && `${url}/release/${projectGroupId}/${releaseId}`,
    isPublic: currentGroup?.publicOnPortal,
  };
}

export default useReportUrl;
